import { useState } from "react"

export default function PlaceholderedImage({ src, ...props }) {
    const [url, setUrl] = useState(src)
    const handleNotFound = () => {
        setUrl('/media/images/notFound.jpg')
    }
    return (
        <>
            <img
                data-source={src}
                src={url}
                onError={handleNotFound}
                {...props}
            />

        </>
    )
}